const faq = document.querySelector('.faq-page')
const qna = faq.querySelectorAll('.qna')
const categories = faq.querySelectorAll('.category')
// Set initial answer height
qna.forEach(qnaItem => {
	const answer = qnaItem.querySelector('.copy')
	qnaItem.style.setProperty('--answer-height', `${answer.scrollHeight}px`)
})
categories.forEach(category => {
	const content = category.querySelector('.qna-container')
	category.style.setProperty('--container-height', `${content.scrollHeight}px`)
})

window.addEventListener('resize', () => {
	qna.forEach(qnaItem => {
		qnaItem.style.setProperty('--answer-height', 'auto')
		const answer = qnaItem.querySelector('.copy')
		qnaItem.style.setProperty('--answer-height', `${answer.scrollHeight}px`)
	})

	categories.forEach(category => {
		category.style.setProperty('--container-height', 'auto')
		const content = category.querySelector('.qna-container')
		category.style.setProperty(
			'--container-height',
			`${content.scrollHeight}px`
		)
	})
})

// Toggle button active state
qna.forEach(question => {
	const button = question.querySelector('.qna .toggle')
	question.addEventListener('click', () => {
		button.classList.toggle('active')
	})
})
categories.forEach(category => {
	const button = category.querySelector('.category-name-container .toggle')
	const group = category.querySelector('.category-name-container')
	group.addEventListener('click', () => {
		const content = category.querySelector('.qna-container')
		category.style.setProperty(
			'--container-height',
			`${content.scrollHeight}px`
		)
		button.classList.toggle('active')
		if (!button.classList.contains('active')) {
			button.classList.toggle('close')
		} else {
			button.classList.remove('close')
		}
	})
})
